"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _remarkBreaks = _interopRequireDefault(require("remark-breaks"));

var _style = require("@widergy/web-utils/lib/style");

var _UTSkeleton = _interopRequireDefault(require("../UTSkeleton"));

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _theme = require("./theme");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var variants = ['xxxsmall', 'xxsmall', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'xxxlarge', 'title', 'largeTitle', 'extraLight', 'light', 'semibold', 'bold', 'extrabold', 'primary', 'secondary', 'alternative', 'gray', 'darkGray', 'white', 'error', 'uppercase', 'lowercase'];

var UTLabel = /*#__PURE__*/function (_PureComponent) {
  _inherits(UTLabel, _PureComponent);

  function UTLabel(props) {
    var _this;

    _classCallCheck(this, UTLabel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UTLabel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.setTitle();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      _this.setTitle();
    });

    _defineProperty(_assertThisInitialized(_this), "setTitle", function () {
      if (!_this.ref) return;

      var _this$ref$getBounding = _this.ref.getBoundingClientRect(),
          childWidth = _this$ref$getBounding.width;

      var parent = _this.ref.parentElement;
      if (!parent) return;

      var _parent$getBoundingCl = parent.getBoundingClientRect(),
          parentWidth = _parent$getBoundingCl.width; // eslint-disable-next-line react/no-did-update-set-state


      _this.setState({
        withHoverTitle: childWidth > parentWidth + 10
      });
    });

    _this.ref = null;
    _this.state = {
      withHoverTitle: false
    };
    return _this;
  }

  _createClass(UTLabel, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          tag = _this$props.tag,
          withoutMarkdown = _this$props.withoutMarkdown,
          propStyle = _this$props.style;
      var withHoverTitle = this.state.withHoverTitle;
      var style = (0, _style.retrieveClassNamesFromProps)(variants, classes, this.props);

      var handleCustomTag = function handleCustomTag(prop) {
        var CustomTag = tag;
        return _react["default"].createElement(CustomTag, {
          ref: function ref(_ref) {
            return _this2.ref = _ref;
          },
          title: withHoverTitle && (prop.children || prop),
          style: propStyle,
          key: prop.children,
          className: withoutMarkdown && className
        }, prop.children || prop);
      };

      var renderLinkComponent = function renderLinkComponent(prop) {
        return _react["default"].createElement("a", {
          href: prop.href,
          rel: "noopener noreferrer",
          target: "_blank",
          className: _stylesModule["default"].link
        }, prop.children);
      };

      var value = Array.isArray(children) ? children.join('') : isNaN(children) ? children : "".concat(children); // eslint-disable-line

      return _react["default"].createElement(_UTSkeleton["default"], null, withoutMarkdown ? handleCustomTag(value) : _react["default"].createElement(_reactMarkdown["default"], {
        source: value,
        escapeHtml: false,
        plugins: [_remarkBreaks["default"]],
        unwrapDisallowed: true,
        disallowedTypes: ['root', 'paragraph'],
        className: " ".concat(className, "  ").concat(classes.base, "  ").concat(style, " "),
        renderers: {
          link: renderLinkComponent,
          text: handleCustomTag
        }
      }, value));
    }
  }]);

  return UTLabel;
}(_react.PureComponent);

UTLabel.defaultProps = {
  tag: 'span'
};
UTLabel.propTypes = {
  classes: _propTypes.any,
  // eslint-disable-line react/forbid-prop-types
  className: _propTypes.string,
  tag: _propTypes.string,
  withoutMarkdown: _propTypes.bool
};

var _default = (0, _WithTheme["default"])(_theme.retrieveStyle)(UTLabel);

exports["default"] = _default;